import supabase from './supabaseClient';

/**
 * Utility to check if a user is an admin based on subscription status
 * @param {Object} user - The current user object 
 * @returns {Promise<Boolean>} - True if user is admin, false otherwise
 */
export const checkAdminStatus = async (user) => {
  if (!user) return false;
  
  try {
    const { data, error } = await supabase
      .from('user_profiles')
      .select('subscription_status')
      .eq('user_id', user.id)
      .single();
      
    if (error) {
      console.error('Error checking admin status:', error);
      return false;
    }
    
    return data?.subscription_status === 'admin';
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};

/**
 * Perform admin authentication check and redirect if needed
 * @param {Object} user - The current user object
 * @param {Function} setIsAdmin - State setter for admin status
 * @param {Function} navigate - React router navigate function
 * @param {String} redirectPath - Path to redirect non-admins to
 * @returns {Promise<Boolean>} - True if user is admin, false otherwise
 */
export const performAdminCheck = async (user, setIsAdmin, navigate, redirectPath) => {
  const isAdmin = await checkAdminStatus(user);
  setIsAdmin(isAdmin);
  
  if (!isAdmin) {
    if (!user) {
      // Not logged in, redirect to login with return path
      navigate('/signin', { state: { from: redirectPath } });
    } else {
      // Logged in but not admin, redirect to resources page
      navigate('/resources');
    }
  }
  
  return isAdmin;
};

const adminUtils = {
  checkAdminStatus,
  performAdminCheck
};

export default adminUtils; 